<template>
    <div class="container">
        <h1>Empresa</h1>
        <template v-if="!loading">
            <div v-if="!error" class="container">
                <h3>Datos empresa</h3>
                <b-row>
                    <b-col>
                        <b-form>
                            <b-form-group style="font-size: 1rem;" label="Empresa">
                                <b-form-input v-model="form.nombre_entidad" :disabled="disabled"
                                v-validate="'required'"
                                name="Empresa">
                                </b-form-input>
                                <span class="error">{{ errors.first('Empresa') }}</span>
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col>
                        <b-form>
                            <b-form-group style="font-size: 1rem;" label="CIF">
                                <b-form-input v-model="form.cif" disabled
                                v-validate="'required'"
                                name="CIF"></b-form-input>
                                <span class="error">{{ errors.first('CIF') }}</span>
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form>
                            <b-form-group style="font-size: 1rem;" label="Dirección">
                                <b-form-input v-model="form.direccion" :disabled="disabled"
                                v-validate="'required'"
                                name="Dirección"></b-form-input>
                                <span class="error">{{ errors.first('Dirección') }}</span>
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form>
                            <b-form-group style="font-size: 1rem;" label="Provincia">
                                <b-form-input v-model="form.codigo_provincia_ine" :disabled="disabled"></b-form-input>
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col>
                        <b-form>
                            <b-form-group style="font-size: 1rem;" label="Website">
                                <b-form-input v-if="!disabled" v-model="form.website"></b-form-input>
                                <a :href="form.website" v-else target="_blank">{{form.website}}</a>
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form>
                            <b-form-group style="font-size: 1rem;" label="Teléfono">
                                <b-form-input v-model="form.telefono_principal" :disabled="disabled"></b-form-input>
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col>
                        <b-form>
                            <b-form-group style="font-size: 1rem;" label="Email">
                                <b-form-input v-model="form.email_principal" :disabled="disabled" v-validate="'required'" name="Email"></b-form-input>
                                <span class="error">{{ errors.first('Email') }}</span>
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form>
                            <b-form-group style="font-size: 1rem;" label="Ambito presupuesto provincias">
                                <!-- <b-form-input v-model="ambitos" :disabled="disabled"></b-form-input> -->
                                <multiselect
                                placeholder=""
                                deselect-label="Click o enter para deseleccionar"
                                select-label="Click o enter para seleccionar"
                                v-model="ambitos"
                                :options="ambitos_options"
                                :multiple="true"
                                :close-on-select="false"
                                label="nombre_provincia_ine"
                                track-by="zeus_codigo_provincia_ine"
                                disabled>
                                </multiselect>
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <!-- TODO -->
                    <!-- <b-col>
                        <b-form>
                            <b-form-group style="font-size: 1rem;" label="Mercado">
                                <b-form-select v-model="mercado" :options="['', 'GC', 'CC']" :disabled="disabled"
                                v-validate="'required'"
                                name="Mercado"/>
                                <span class="error">{{ errors.first('Mercado') }}</span>
                            </b-form-group>
                        </b-form>
                    </b-col> -->
                </b-row>
                <b-row>
                    <b-col>
                        <b-form>
                            <b-form-group style="font-size: 1rem;" label="Descripción">
                                <trumbowyg class="form-control" name="content" v-model="form.descripcion_comercial" :config="config"></trumbowyg>
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <h3>Archivos</h3>
                <b-row>
                    <b-col>
                        <b-form>
                            <b-form-group style="font-size: 1rem;" label="Logo (.png / .jpeg)">
                                <img style="max-width:50%" v-if="form.logo_empresa" :src="parseMedia(form.logo_empresa)" alt="">
                                <b-button v-if="form.logo_empresa && !disabled" variant="danger" @click="deleteLogo">Borrar logo</b-button>
                                <br>
                                <input v-if="!disabled" ref="logo" type="file" id="logo" name="logo" accept="image/png, image/jpeg"/>
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form>
                            <b-form-group style="font-size: 1rem;" label="Documento presentación (.pdf)">
                                <a v-if="form.documentacion_comercial" :href="parseMedia(form.documentacion_comercial)" target="_blank">
                                    {{form.documentacion_comercial.split('/')[form.documentacion_comercial.split('/').length-1]}}
                                </a>
                                <b-button @click="deleteDocumento" v-if="form.documentacion_comercial && !disabled" variant="danger">Borrar documento</b-button>
                                <br>
                                <input v-if="!disabled" ref="file" type="file" id="doc" name="doc" accept="application/pdf" :disabled="disabled"/>
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
            </div>
            <div v-if="!error && !disabled" style="text-align: end;">
                <b-button @click="getData">Cancelar</b-button>
                <b-button @click="saveData">Guardar</b-button>
            </div>
            <div v-else class="container">
                <h3 style="color:red">{{error}}</h3>
            </div>
        </template>
        <template v-else>
            Loading...
        </template>
    </div>
</template>

<style>
.trumbowyg-button-pane{
    z-index: 0;
}
</style>

<script>
import Trumbowyg from 'vue-trumbowyg';
import 'trumbowyg/dist/ui/trumbowyg.css';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  name: 'Form',
  components: {
    Trumbowyg
  },
  data: function () {
    return {
      disabled: true,
      form: null,
      loading: true,
      error: null,
      config: {
        disabled: true,
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['superscript', 'subscript'],
          ['link'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['removeformat'],
          ['fullscreen']
        ]
      },
      mercado: null,
      ambitos: [],
      ambitos_options: []
    };
  },
  methods: {
    parseMedia: function (logo) {
      return logo.replace('api/entidad', 'media');
    },
    deleteLogo: function () {
      this.$http.delete('entidad/' + this.form.id + '/logo_empresa/').then(result => {
        this.form.logo_empresa = null;
      });
    },
    deleteDocumento: function () {
      this.$http.delete('entidad/' + this.form.id + '/documentacion_comercial/').then(result => {
        this.form.documentacion_comercial = null;
      });
    },
    saveData: function () {
      this.$validator.validate().then(result => {
        if (!result) {
          alert('Tienes algún error en el formulario');
        } else {
          this.disabled = true;

          var formData = new FormData();
          if (this.$refs.logo.files.length > 0) {
            formData.append('logo_empresa', this.$refs.logo.files[0], this.$refs.logo.files[0].name);
          }
          if (this.$refs.file.files.length > 0) {
            formData.append('documentacion_comercial', this.$refs.file.files[0], this.$refs.file.files[0].name);
          }
          formData.append('id_entidad', this.form.id);

          delete this.form.logo_empresa;
          delete this.form.documentacion_comercial;
          Promise.all([
            this.$http.put('entidad/' + this.form.id + '/', this.form)
            // this.$http.post('entidad/' + this.form.id + '/ambitos/', {mercado: this.mercado, ambitos: this.ambitos.map(e => e.zeus_codigo_provincia_ine)})
          ]).then(responses => {
            this.$http.post('upload_entidad/', formData).then(response => {
              this.getData();
              alert('Datos guardados con exito!');
              this.disabled = false;
            });
          });
        }
      });
    },
    getData: function () {
      this.loading = true;
      this.error = null;
      if (this.$route.params.document === undefined) {
        this.error = 'No se ha encontrado la entidad';
        this.loading = false;
        return;
      }
      if (this.$route.params.edit) {
        this.disabled = this.$route.params.edit !== 'edit';
      } else {
        this.disabled = true;
      }
      this.config.disabled = this.disabled;

      this.$http.get('geoprovinciaempresa/', {params: {not_paginated: true, ordering: 'nombre_provincia_ine'}}).then(response => {
        this.ambitos_options = response.data;

        this.$http.get('entidad_search/', {params: {id_web: this.$route.params.document}}).then(response => {
          this.form = response.data.results[0];

          this.ambitos = [];
          this.mercado = '';
          if (this.form.ambitos.length > 0) {
            this.mercado = this.form.ambitos[0].mercado;
            for (let index = 0; index < this.form.ambitos.length; index++) {
              const element = this.form.ambitos[index];
              this.ambitos.push(this.ambitos_options.find(e => e.zeus_codigo_provincia_ine === element.codigo_provincia_ine));
            }
          }
          this.loading = false;
        }, response => {
          this.error = response.data.detail;
          this.loading = false;
        }).catch(function () {
          this.error = 'No se ha encontrado la entidad';
          this.loading = false;
        });
      });
    }
  },
  mounted: function () {
    this.getData();
  },
  watch: {
    '$route': function () {
      this.getData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Form/Form.vue